// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class NominationVote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  code?: string;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  endDate!: Date;
  personId?: number;
  sent?: Date;
  viewed?: Date;
  voted?: Date;
  year!: number;
  person!: Person;
}

